/* Support for old browsers... */

// Edge lacks Array.includes, but some of our dependencies use it so we can't eliminate it
import "polyfill-array-includes";

// For IE11
import "promise-polyfill/src/polyfill";

// For IE11
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, "startsWith", {
    value: function (search: any, rawPos: any) {
      const pos = rawPos > 0 ? Math.trunc(rawPos) : 0;
      return this.slice(pos, pos + search.length) === search;
    },
  });
}
